import $ from "jquery";

(function () {
  const {trackGa, track} = require('./../analytics/analytics');
  const date = new Date;
  const startDate = __WEBINARSTART__;
  const endDate = __WEBINAREND__;
  const auth = localStorage.getItem('emailCollect') !== null;
  const $popUp = $('#popUp');
  const modalName = `popup_${endDate}`;
  const firstMClosed = () => localStorage.getItem(modalName);
  const $popUpData = $('.popUp-data');
  const disableModals = () => {
    localStorage.setItem(modalName, "true");
  }
  const sendEvents = (status) => {
    let label = location.pathname.replace(/\//g, '');
    label = label === 'web-app' ? 'webapp' : label;
    const action = status ? 'success' : 'show';
    track("LANDING|PopUp", action, `webinar23072807-${label}`);
    trackGa(action, 'PopUp', `webinar23072807-${label}`);
  }

  let initFirstTime = 5000;

  const displayConfirmation = () => {
    $('.popUp-viewInit').hide();
    $('.popUp-viewConfirmation').css('display', 'flex');
    disableModals();
  }

  const neAlert = (status, category) => {
    if (status) {
      $popUpData.addClass(`popUp-alert-${category}`);
    } else {
      $popUpData.removeClass(`popUp-alert-${category}`);
    }
  }

  $('.popUp-data input').on('click', (e) => {
    if ($popUpData.hasClass('popUp-alert-email')) {
      e.target.placeholder === 'Email' && neAlert(false, 'email');
    }
  });

  const initForm = () => {
    $('.popUp__book').on('click', (e) => {
      const email = $popUpData.children(":last").val();
      if (emailIsValid(email)) {
        sendReq(email);
      } else {
        neAlert(true, 'email');
      }
    });
  }

  const sendReq = (email) => {
    log(`PopUp Data: ${email}`);
    // mindbox("async", {
    //   operation: "webinar2307",
    //   data: {
    //     customer: {
    //       email: email,
    //       subscriptions: [
    //         {
    //           brand: "AMZScout",
    //           pointOfContact: "Email"
    //         }
    //       ]
    //     }
    //   }
    // });
    sendEvents(true);
    displayConfirmation();
  }

  const displayPopUp = () => {
    setTimeout(() => {
      if (document.hidden) {
        displayPopUp();
        initFirstTime += initFirstTime;
      } else if (!auth) {
        initForm();
        $popUp.fadeIn();
        sendEvents(false);
      }
    }, initFirstTime);
  }

  if (date >= new Date(startDate) && date <= new Date(endDate)) {
    if (!firstMClosed()) {
      displayPopUp();
    }
  } else {
    log("PopUp Time Expired!")
  }

  $('#popUp-close').on('click', () => {
    if (!firstMClosed()) {
      localStorage.setItem(modalName, "true");
    }
    $popUp.fadeOut();
  });

}());
